export default __webpack_public_path__ + "static/media/doctor-potrait.491809a6.png";